type Attrs = Record<string, unknown>

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[]
  }
}

/** Pushes an event to the dataLayer (GTM-ready). Page path and language are added to every event. */
export function trackEvent(name: string, attrs?: Attrs) {
  if (typeof window === 'undefined') return
  const payload = {
    event: name,
    page_path: window.location.pathname,
    page_lang: document.documentElement.lang || undefined,
    ...attrs,
  }
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(payload)
  console.debug('[Analytics]', name, payload)
}

/* Referrers that identify AI / answer-engine traffic. */
const AI_REFERRERS: Record<string, string> = {
  'chatgpt.com': 'ChatGPT',
  'chat.openai.com': 'ChatGPT',
  'perplexity.ai': 'Perplexity',
  'copilot.microsoft.com': 'Copilot',
  'gemini.google.com': 'Gemini',
  'claude.ai': 'Claude',
}

const SEARCH_REFERRERS = ['google.', 'bing.com', 'duckduckgo.com', 'search.yahoo.com', 'ecosia.org', 'qwant.com']

/** One landing-attribution event per session: channel, referrer, UTM, landing page. */
export function trackLanding() {
  if (typeof window === 'undefined') return
  try {
    if (window.sessionStorage.getItem('bciti-landing')) return
    window.sessionStorage.setItem('bciti-landing', '1')
  } catch {
    // storage unavailable — still record once for this load
  }
  const params = new URLSearchParams(window.location.search)
  let host = ''
  try {
    host = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : ''
  } catch {
    host = ''
  }
  const aiSource = Object.keys(AI_REFERRERS).find((d) => host === d || host.endsWith(`.${d}`))
  const utmSource = params.get('utm_source') || undefined
  const channel = aiSource || /chatgpt|openai|perplexity|copilot|gemini/i.test(utmSource ?? '')
    ? 'ai_referral'
    : host && SEARCH_REFERRERS.some((s) => host.includes(s))
      ? 'organic_search'
      : host && host !== window.location.hostname
        ? 'referral'
        : utmSource
          ? 'campaign'
          : 'direct'

  trackEvent('Landing', {
    channel,
    ai_source: aiSource ? AI_REFERRERS[aiSource] : undefined,
    referrer_host: host || undefined,
    utm_source: utmSource,
    utm_medium: params.get('utm_medium') || undefined,
    utm_campaign: params.get('utm_campaign') || undefined,
    landing_page: window.location.pathname,
  })
}
